import React from 'react';
import { render } from 'react-dom';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'console-polyfill';
import 'whatwg-fetch';              // fetch API 폴리필
import 'url-search-params-polyfill' // URLSearchParams 폴리필
import 'intl';                      // Intl API 폴리필
import 'intl/locale-data/jsonp/en'; // 영어 지원
import 'intl/locale-data/jsonp/ko'; // 한국어 지원
import 'intl/locale-data/jsonp/zh'; // 중국어 지원
import './i18n';
import { installClientEventLogging } from './Lib/clientEventLog';

// Components
import App from './App';
import ErrorBoundary from './Components/ErrorBoundary';

installClientEventLogging();

render(
    <ErrorBoundary>
        <App />
    </ErrorBoundary>,
    document.getElementById('root'),
);
